// src/utils/flattenJson.ts

import { Translations } from "./loadTranslations";

export interface FlattenedTranslation {
	key: string;
	translations: {
	  [language: string]: string;
	};
      }
      
      export const flattenTranslations = (
	translations: Translations
      ): FlattenedTranslation[] => {
	const flattened: { [key: string]: FlattenedTranslation } = {};
      
	const languages = Object.keys(translations);
      
	for (const language of languages) {
	  const files = translations[language];
	  for (const fileName in files) {
	    flattenObject(files[fileName], '', (key, value) => {
	      const fullKey = `${fileName}.${key}`;
	      if (!flattened[fullKey]) {
		flattened[fullKey] = { key: fullKey, translations: {} };
	      }
	      flattened[fullKey].translations[language] = value;
	    });
	  }
	}
      
	return Object.values(flattened);
      };
      
      const flattenObject = (
	obj: any,
	parentKey: string,
	callback: (key: string, value: string) => void
      ) => {
	for (const key in obj) {
	  const value = obj[key];
	  const newKey = parentKey ? `${parentKey}.${key}` : key;
      
	  if (typeof value === 'string') {
	    callback(newKey, value);
	  } else if (typeof value === 'object') {
	    flattenObject(value, newKey, callback);
	  }
	}
      };
      